import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "WoocommerceNotice woocommerce-error"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 mt-6 mb-6 text-center lg:mb-[52px]" }, "Utwórz konto", -1)
const _hoisted_4 = { class: "mt-[40px] lg:mt-[52px]" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = { class: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" }
const _hoisted_7 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "mx-auto w-full max-w-[483px] mt-[15.5px] lg:mt-[44px]"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "Title mb-3" }, "Twoje konto zostało utworzone", -1)
const _hoisted_13 = { class: "Text mb-4" }
const _hoisted_14 = ["href"]

import { Form } from 'vee-validate';
import { schema } from './schema';
import { initialValues } from './initialValues';
import { scrollToTop } from '../../helpers/scrollToTop';
import PatientData from '../shared/PatientData.vue';
import EmailRegisterField from '../shared/Fields/RegisterFields/EmailRegisterField.vue';
import Password from '../shared/Fields/RegisterFields/Password.vue';
import ConfirmPassword from '../shared/Fields/RegisterFields/ConfirmPassword.vue';
import AcceptRegistrationTerms from '../shared/Fields/RegisterFields/AcceptRegistrationTerms.vue';
import { useOnSubmit } from './hooks/useOnSubmit';


export default {
  __name: 'PatientRegistration',
  setup(__props) {

const { isSubmitting, onSubmit, status, registeredEmail, responseMessage } = useOnSubmit();

const url = jsData.siteUrl;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(status) !== 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(status) === 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(responseMessage)), 1))
            : _createCommentVNode("", true),
          _hoisted_3,
          _createVNode(_unref(Form), {
            "initial-values": _unref(initialValues)(_ctx.data, true),
            "validation-schema": _unref(schema),
            onInvalidSubmit: _unref(scrollToTop),
            enctype: "multipart/form-data",
            class: "erecepta-form",
            onSubmit: _unref(onSubmit),
            onKeydown: _cache[0] || (_cache[0] = _withKeys($event => ($event.preventDefault()), ["enter"])),
            "keep-values": "true"
          }, {
            default: _withCtx(() => [
              _createVNode(EmailRegisterField),
              _createVNode(Password),
              _createVNode(ConfirmPassword),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(PatientData)
              ]),
              _createVNode(AcceptRegistrationTerms),
              _createElementVNode("button", {
                class: _normalizeClass(["Button relative mt-6 lg:mt-8 px-8 py-4 w-full", {
                    'is-submitting': _unref(isSubmitting),
                }]),
                type: "submit"
              }, [
                (!_unref(isSubmitting))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Utwórz konto "))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_6, [
                  (_unref(isSubmitting))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["initial-values", "validation-schema", "onInvalidSubmit", "onSubmit"])
        ]))
      : _createCommentVNode("", true),
    (_unref(status) === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("p", _hoisted_13, "Potwierdzenie zostało wysłane do: " + _toDisplayString(_unref(registeredEmail)), 1),
          _createElementVNode("a", {
            class: "Button Button--bordered px-8 py-3 lg:mb-[328px] w-full lg:w-auto",
            href: `${_unref(url)}/my-account`
          }, " Zaloguj się ", 8, _hoisted_14)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}